import { CloseIcon } from '../../../assets/icons/Svg'
import { useDispatch } from 'react-redux';
import { clearTypeModal, clearTypeOfCategory, clearTypeOfShowModalType } from '../../../features/modal/modalSlice';
import Loading from '../../ui/Loading';
import ErrorMessage from '../../ui/ErrorMessage';
import { clearPackageData, clearSelectedPackageId } from '../../../features/package/packageSlice';
import { useQueryData } from '../../../hooks/api/useQueryData';

interface PackageModalProps {
    typeOfView: string
}

export default function PackageModal({ typeOfView = 'user' }: PackageModalProps) {

    const dispatch = useDispatch();
    const { packageData, isErrorPackageData, isLoadingPackageData, } = useQueryData()
    
    const handleClosePackageModal = () => {
        dispatch(clearTypeOfCategory());
        dispatch(clearTypeModal());
        dispatch(clearTypeOfShowModalType())
        dispatch(clearPackageData())
        dispatch(clearSelectedPackageId())
    }

    return (
        <div className="fixed inset-0 m-0 p-0 bg-black bg-opacity-30 backdrop-blur-sm flex justify-center items-center z-[100] overflow-hidden">
            <div className="relative w-[90%] mx-5 bg-white rounded-lg shadow px-5 flex md:w-[75%] lg:max-w-[45%] lg:mx-auto overflow-hidden">
                <div className="flex flex-col w-full h-[90vh] overflow-hidden">
                    <div className="flex flex-col py-5 h-full">
                        <div className="flex justify-between items-center py-1">
                            <p className="text-sm font-semibold leading-tight text-slate-900">
                                {'Package Details'}
                            </p>
                            <button
                                type="button"
                                className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 inline-flex justify-center items-center"
                                onClick={handleClosePackageModal}
                            >
                                <CloseIcon />
                            </button>
                        </div>
                        <hr className="h-px bg-gray-200 border-0" />

                        <div className='grid grid-cols-3 gap-2 py-4'>
                            <div className='flex flex-col'>
                                <p className='text-sm'>Name:</p>
                                <p className='text-sm font-medium'>
                                    {packageData?.packageName}
                                </p>
                            </div>
                            <div className='flex flex-col'>
                                <p className='text-sm'>Cups</p>
                                <p className='text-sm font-medium'>
                                    {packageData?.qty}
                                </p>
                            </div>
                            <div className='flex flex-col'>
                                <p className='text-sm'>Amount</p>
                                <p className='text-sm font-medium'>
                                    {/* {packageData?.packageQuantity?.toLocaleString()} */}
                                </p>
                            </div>
                        </div>

                        {/* Scrollable table area (vertical only) */}
                        <div className="flex-1 overflow-y-auto">
                            <div className="border rounded relative h-full">
                                <table className="w-full text-sm border-collapse">
                                    <thead className="bg-gray-100 text-gray-700 uppercase text-xs sticky top-0 z-10">
                                        <tr>
                                        <th className="py-3 px-4 text-left border-b">Name</th>
                                        <th className="py-3 px-4 text-left border-b">Category</th>
                                        <th className="py-3 px-4 text-left border-b">Size</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        { isLoadingPackageData ? (
                                            <tr>
                                                <td colSpan={3}>
                                                <Loading message="Loading product..." />
                                                </td>
                                            </tr>
                                        ) : isErrorPackageData ? (
                                            <tr>
                                                <td colSpan={3}>
                                                    <ErrorMessage message="Unable to load product. Please try again later or refresh the page." />
                                                </td>
                                            </tr>
                                        ) : packageData?.items.length === 0 ? (
                                            <tr>
                                                <td
                                                    colSpan={3}
                                                    className="text-center py-4 text-gray-500 border-t"
                                                >
                                                    No products found.
                                                </td>
                                            </tr>
                                        ) : (
                                            packageData?.items?.map((prod) => (
                                                <tr
                                                    key={prod?.productID}
                                                    className="hover:bg-gray-50 transition-colors"
                                                >
                                                    <td className="py-3 px-4 border-b">
                                                        {prod?.productName}
                                                    </td>
                                                    <td className="py-3 px-4 border-b">
                                                        {prod?.categoryName}
                                                    </td>
                                                    <td className="py-3 px-4 border-b">
                                                        {prod?.size === 'None' ? '' : prod?.size}
                                                    </td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
